import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { TEALIUM_CAJA_CREATE_FLOW_TYPE } from 'src/app/constants/dispatcherId';
import tealium from 'src/app/state/dispatcher/tealium';
import { useQueryParams } from 'src/app/views/hooks/useQueryParams';
import type AppState from 'src/types/appState';

export const useTealiumCreateFlowType = () => {
  const dispatch = useDispatch();
  const { isDataCleanupComplete } = useSelector(
    (state: AppState) => ({
      isDataCleanupComplete: state.app.isDataCleanupComplete,
    }),
    shallowEqual,
  );

  const { getReferrerParam } = useQueryParams();

  useEffect(() => {
    const referrerParam = getReferrerParam();
    if (isDataCleanupComplete && referrerParam) {
      dispatch(tealium(TEALIUM_CAJA_CREATE_FLOW_TYPE, referrerParam));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataCleanupComplete]);
};
